import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import {Context} from '../../index';
import {CONTACTS} from '../../data/siteData';
import logo from '../../images/logo.png';
import vkLogo from '../../images/vk-logo.svg';
import styles from './Footer.module.css';

const Footer = () => {
    const {global} = useContext(Context);

    if (global.isAdminPage) return null;

    return (
        <footer className={styles.footer}>
            <div className={styles.inner}>
                <div className={styles.about}>
                    <Link to="/" className={styles.brand}>
                        <img src={logo} alt="4 Цвета"/>
                    </Link>
                    <p>Полиграфия, сувенирная продукция и дизайн в Томске.</p>
                </div>
                <address className={styles.contacts}>
                    <div>
                        <span>Телефоны</span>
                        <a href={`tel:${CONTACTS.mobile.replace(/\D/g, '')}`}>{CONTACTS.mobile}</a>
                        <a href={`tel:${CONTACTS.phone.replace(/\D/g, '')}`}>{CONTACTS.phone}</a>
                    </div>
                    <div>
                        <span>Email</span>
                        <a href={`mailto:${CONTACTS.email}`}>{CONTACTS.email}</a>
                    </div>
                    <div>
                        <span>Адрес</span>
                        <strong>{CONTACTS.address}</strong>
                    </div>
                    <a className={styles.vkLink} href={CONTACTS.vk} target="_blank" rel="noreferrer">
                        <img src={vkLogo} alt="" aria-hidden="true"/>
                        vk.ru/4zveta
                    </a>
                </address>
            </div>
            <div className={styles.bottom}>
                <span>© {new Date().getFullYear()} 4 Цвета</span>
                <span>Цены, указанные на сайте, не являются публичной офертой.</span>
            </div>
        </footer>
    );
};

export default Footer;
